import React, { Fragment } from 'react'
import { GridElementWorkOrderFillRate } from '../GridWorkOrderFillRate/GridElementWorkOrderFillRate'

import { NoRows } from '../../../ElementList/NoRows'
import { SortField } from '../../../../interfaces/DataGrid/DataGridSettings'
import { DataGrid } from '../../../DataGrid/DataGrid'
import { dataGridViewerSettings } from './workOrderFillRateConfig'
import { WorkOrderFillRateData } from '../../../../interfaces/DashBoard/FillRate'

interface WorkOrderFillRateElementListProps {
  plannerList: WorkOrderFillRateData[]
  // page: number
  // totalPages: number
  // pageSize: number
  // handlePagination: (updatePage: number) => void
  // handlePageSize: (
  //   event: ChangeEvent<{ name?: string | undefined; value: unknown }>,
  //   child: ReactNode
  // ) => void
  sorters: SortField[]
  handleOnSortChanged: (sorters: SortField[]) => void
}

export const WorkOrderFillRateElementList: React.FC<WorkOrderFillRateElementListProps> =
  ({ plannerList, handleOnSortChanged, sorters }) => {
    return (
      <Fragment>
        <DataGrid
          items={plannerList}
          settings={dataGridViewerSettings}
          sorters={sorters}
          onSortChanged={handleOnSortChanged}
          displayHeader={false}
        >
          {(order) => <GridElementWorkOrderFillRate element={order} />}
        </DataGrid>

        {plannerList.length <= 0 && <NoRows />}
      </Fragment>
    )
  }
